import { ComponentStyleConfig } from '@chakra-ui/react';

export const Input: ComponentStyleConfig = {
  baseStyle: {
    '&[type="password"]': {
      fontFamily: 'password-dots',
      letterSpacing: '2px',
      textIndent: '1px',
    },
    _focus: {
      // TODO: Disable this after making designers agree with focus rings
      boxShadow: 'none',
    },
    _invalid: {
      borderColor: 'R.40',
    },
  },
  variants: {
    outline: {
      field: {
        color: 'M.70',
        borderColor: 'M.30',
        borderRadius: 4,
        _invalid: {
          borderColor: 'R.40',
        },
      },
    },
  },
  sizes: {
    sm: {
      field: {
        height: '28px',
        fontSize: 'xs',
      },
    },
    md: {
      field: {
        height: '39px',
        fontSize: 'sm',
      },
    },
    lg: {
      field: {
        px: 3,
        height: '49px',
        fontSize: 'sm',
      },
    },
  },
  defaultProps: {
    size: 'lg',
  },
};
